import { useQuery } from "@tanstack/react-query";
import { composeUrl } from "@foundation/util";
import { SECTION_FRONT_REFRESH_INTERVAL_IN_MS } from "~constants";
import type { SectionFrontSecurity } from "~types/sectionfront";
import { logError } from "~utils/newrelic/newrelicBrowser";

async function fetchBfixData(dateString: string) {
  const sectionFrontApi = composeUrl({
    pathname: "/bazaar/api/section-front/bfix-rates",
    searchParams: { dateString },
    trailingSlash: false,
  });

  try {
    const response = await fetch(sectionFrontApi, {
      credentials: "same-origin",
    });

    if (!response.ok) return null;

    return response.json();
  } catch (error) {
    logError(new Error("Error fetching bfix data"), {
      dateString,
      errorMsg: JSON.stringify(error),
    });

    throw error;
  }
}

export const useBfixRatesData = (dateString?: string) =>
  useQuery<SectionFrontSecurity[]>({
    queryKey: ["bfixRatesData", dateString],
    queryFn: () => {
      if (!dateString) return Promise.resolve([]);

      return fetchBfixData(dateString);
    },
    refetchInterval: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
    // disable first fetch, page loads with server data
    enabled: Boolean(dateString),
  });
